import { EventsType } from '../types'

/**
 * Default element to listen for events on
 */
export const DEFAULT_ELEMENT: Document = document

/**
 * The default events to determine activity
 */
export const DEFAULT_EVENTS: EventsType[] = [
  'mousemove',
  'keydown',
  'wheel',
  'DOMMouseScroll',
  'mousewheel',
  'mousedown',
  'touchstart',
  'touchmove',
  'MSPointerDown',
  'MSPointerMove',
  'visibilitychange',
  'focus',
]
